import { useQuery } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

import CreateLayout from 'layouts/CreateLayout';

import ErrorMessage from 'components/ErrorMessage';

import LoadingIndicator from 'primitives/LoadingIndicator';

import DealTabs from './DealTabs';

const GET_FUND_VIA_SYNDICATE_QUERY = gql(`
  query GetFundViaSyndicate($syndicateId: ID!) {
    syndicate(id: $syndicateId) {
      fund {
        id
      }
    }
  }
`);

const CreateDeal: FC = () => {
  const navigate = useNavigate();
  const { fundId: syndicateId } = useParams() as { fundId: string };

  const { data, loading, error } = useQuery(GET_FUND_VIA_SYNDICATE_QUERY, {
    variables: { syndicateId },
  });

  if (loading) return <LoadingIndicator />;

  // if (error) return <ErrorMessage message={error.message} />;

  return (
    <CreateLayout
      onClose={() =>
        navigate(`/fund-dashboard/${data?.syndicate?.fund?.id || syndicateId}/deals-of-fund`)
      }
    >
      <div className="col-span-2">
        <DealTabs />
      </div>
      <div className="col-span-4">
        <Outlet />
      </div>
    </CreateLayout>
  );
};

export default CreateDeal;
